export default "__VITE_ASSET__mFZbTb76__"